<template>
    <div class="group-list-components">
        <div v-if="!show">
            <div  class="group-serch flex justify-between items-end">
                <!-- 筛选 -->
                <form @submit.prevent="fetchGroup" class="pb-6 flex">
                    <el-select
                        v-on:change="selectPlace"
                        class="pr-2"
                        v-model="form.storeId"
                        :placeholder="$t('Common.store_placeholder')">
                        <el-option
                            v-for="item in stores"
                            :key="item.id"
                            :label="item.name"
                            :value="Number(item.id)">
                        </el-option>
                    </el-select>
                    <el-select
                        class="pr-2"
                        v-on:change="fetchGroup"
                        v-model="form.placeId"
                        :placeholder="$t('Common.place_placeholder')">
                        <el-option
                            v-for="item in places"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select
                        class="pr-2"
                        v-on:change="fetchGroup"
                        v-model="form.coachId"
                        :placeholder="$t('Common.choose_coach')">
                        <input
                            class="croup-coach"
                            type="text"
                            v-model="searchText" >
                        <el-option
                            v-for="item in filterList"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id"
                            :disabled="item.id == 'no'">
                        </el-option>
                    </el-select>
                </form>
                <div class="group-handle flex">
                    <!-- <el-tooltip effect="dark" content="生成课表" placement="bottom">
                        <div
                            @click="handleCreate"
                            class="iconfont icon-fitness-kebiaox"></div>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" :content="$t('tooltip.check')" placement="bottom">
                        <div
                            @click="handleShow"
                            class="iconfont icon-fitness-yanjing2"></div>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                        <div
                            class="iconfont edit icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy"
                            @click="handleEdit"></div>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.add')" placement="bottom">
                        <div
                            class="iconfont add icon-fitness-tianjiawenjian"
                            @click="handleAdd"></div>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                        <div
                            class="iconfont delete icon-fitness-shanchu"
                            @click="handleDelete"></div>
                    </el-tooltip>
                </div>
            </div>
            <div class="group-data flex">
                <div class="group-data-condition">
                    <el-date-picker
                        ref="picker"
                        style="width: 100%"
                        v-model="form.date"
                        type="date"
                        format="yyyy - MM - dd"
                        value-format="yyyy-MM-dd"
                        v-on:change="selectDay"
                        :placeholder="$t('Common.choose_date')">
                    </el-date-picker>
                    <!-- 课程复制区域 -->
                    <div class="group-data-copy">
                        <div class="flex copy-item items-center justify-between">
                            <p>{{ $t('Course.copy_course') }}</p>
                            <el-select
                                class="pr-2"
                                v-model="copy.placeId"
                                :placeholder="$t('Common.place_placeholder')">
                                <el-option
                                    v-for="item in places"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex copy-item items-center justify-between">
                            <p>{{ $t('Course.jiang') }}</p>
                            <el-date-picker
                                @change="selectTime"
                                style="width: 100%"
                                v-model="copy.srcFrom"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('Common.choose_date')">
                            </el-date-picker>
                        </div>
                        <div class="flex copy-item items-center justify-between">
                            <p>{{ $t('Reception.Third.zhi') }}</p>
                            <el-date-picker
                                @change="selectTime"
                                style="width: 100%"
                                v-model="copy.srcTo"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('Common.choose_date')">
                            </el-date-picker>
                        </div>
                        <div class="copy-text">{{ $t('Course.copy1') }}</div>
                        <div class="flex copy-item items-center justify-between">
                            <p>从</p>
                            <el-date-picker
                                @change="selectTime"
                                style="width: 100%"
                                v-model="copy.destFrom"
                                value-format="yyyy-MM-dd"
                                type="date"
                                :placeholder="$t('Common.choose_date')">
                            </el-date-picker>
                        </div>
                        <div v-if="copy.destFrom" class="copy-text">{{ $t('Reception.Third.zhi') }} {{ copy.toEnd }}</div>
                        <div class="text-center">
                            <el-button
                                class="text-center"
                                type="primary"
                                @click="handlecopy"
                            >{{ $t('Course.copy_button') }}</el-button>
                        </div>
                    </div>
                </div>
                <div class="group-data-content">
                    <table>
                        <thead>
                            <tr>
                                <td style="width: 9%">{{ $t('Course.lesson_time') }}</td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.mon') }}</div>
                                    <div class="group-list-day">{{ weeks[0].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.tues') }}</div>
                                    <div class="group-list-day">{{ weeks[1].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.wed') }}</div>
                                    <div class="group-list-day">{{ weeks[2].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.thur') }}</div>
                                    <div class="group-list-day">{{ weeks[3].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.fri') }}</div>
                                    <div class="group-list-day">{{ weeks[4].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.satu') }}</div>
                                    <div class="group-list-day">{{ weeks[5].dayStr }}</div>
                                </td>
                                <td style="width: 13%" v-if="weeks && weeks.length">
                                    <div>{{ $t('Week.sun') }}</div>
                                    <div class="group-list-day">{{ weeks[6].dayStr }}</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody id="tby" v-if="groupData.length && $$filterPermission('课程-团课课表-团课课表查看')">
                            <tr v-for="(item,index) in cols" :key="index">
                                <td>{{item}}</td>
                                <td v-for="(num, numIndex) in 7" :key="numIndex">
                                    <div
                                        :key="listIndex"
                                        :class="clickIndex == i.id ? 'clicked' : ''"
                                        @click="clickIndex = i.id"
                                        v-for="(i, listIndex) in groupData"
                                        class="group-list-single text-left"
                                        v-if="i.date == weeks[numIndex].day && i.time == item">
                                        <div class="group-list-title flex items-center">
                                            <span class="group-list-icon green" v-if="i.charge">{{ $t('Course.pay') }}</span>
                                            <span>{{ i.lessonName }}</span>
                                        </div>
                                        <div class="group-list-place">{{ i.placeName }}</div>
                                        <div class="group-list-coach">
                                            {{ `${i.coachNickname} [${i.duration}min]` }}
                                        </div>
                                        <div class="group-list-appoint flex items-center">
                                            <span class="group-list-icon orange">{{ $t('Course.about') }}</span>
                                            <span>{{ i.reservedAmt }}/</span>
                                            <span>{{ !i.totalAmt ? $t('Course.limi') : i.totalAmt }}</span>
                                        </div>
                                        <div class="group-list-to flex items-center">
                                            <span class="group-list-icon blue">{{ $t('Course.to') }}</span>
                                            <span>{{ i.signedAmt }}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="!groupData.length && $$filterPermission('课程-团课课表-团课课表查看')">
                            <tr>
                                <td colspan="8">{{ $t('Course.none') }}</td>
                            </tr>
                        </tbody>
                        <tbody v-if="!$$filterPermission('课程-团课课表-团课课表查看')">
                            <tr>
                                <td colspan="8">{{ $t('Course.no_promission') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="show">
            <div class="handle-btn flex justify-between">
                <el-button
                    @click="backList"
                    icon="el-icon-arrow-left"
                    type="primary">
                    {{ $t('Course.back') }}
                </el-button>
                <el-button
                    @click="addAppointment"
                    type="primary"
                    icon="el-icon-plus">
                    {{ $t('Course.add') }}
                </el-button>
            </div>
            <div class="team-show-single">
                <div class="flex show-single-content">
                    <div>{{ $t('Course.name') }}：{{ item.lessonName }}</div>
                    <div>{{ $t('Course.area') }}：{{ item.placeName }}</div>
                    <div>{{ $t('Course.coach') }}：{{ item.coachNickname }}</div>
                </div>
                <div class="flex show-single-content">
                    <div>{{ $t('Course.time') }}：{{ item.lessonTime }}</div>
                    <div>{{ $t('Course.ke_count') }}：{{ item.totalAmtStr }}</div>
                    <div>{{ $t('Course.yi_count') }}：{{ item.reservedAmt }}</div>
                    <div>{{ $t('Course.sign_count') }}：{{ item.signedAmt }}</div>
                </div>
            </div>
            <div class="show-single-table">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    border>
                    <el-table-column prop="cardNum" :label="$t('Common.member_card')" />
                    <el-table-column prop="clientName" :label="$t('Common.name')" />
                    <el-table-column prop="clientType" :label="$t('Common.number_type')" />
                    <el-table-column prop="clientPhone" :label="$t('Common.phone_phone')" />
                    <el-table-column prop="contractNum" :label="$t('Common.use_con')" />
                    <el-table-column prop="province" :label="$t('Common.position')" />
                    <el-table-column prop="status" :label="$t('Reception.Fourth.status')" />
                    <el-table-column prop="province" :label="$t('Common.operating')">
                        <template slot-scope="{row, $index}">
                            <div v-if="row.status != '已取消'">
                                <span v-if="row.status != '已签到'"
                                    @click="handleSign(row)"
                                    class="mr-5 show-single-qiandao">{{ $t('Common.sign') }}
                                </span>
                                <span
                                    @click="handleCancel(row)"
                                    class="show-single-cancle"
                                >{{ $t('Reception.Second.cancel_appoint') }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 编辑课时 -->
        <edit-lessons ref="edit" @fetchGroup="fetchGroup" />
        <!-- 添加预约 -->
        <add-appoint ref="appoint" @fetchItem="fetchItem" />
        <!-- 添加课程 -->
        <add-course ref="addCourse" @fetchGroup="fetchGroup" />
    </div>
</template>

<script>
import { Tabs, TabPane, DatePicker, Radio } from 'element-ui';
// EditLessons
import EditLessons from '@/components/Dialog/Course/EditLessons';
import AddAppoint from '@/components/Dialog/Course/AddAppoint';
import AddCourse from '@/components/Dialog/Course/AddCourse';
import timeMixin from '@/mixins/timeMixin.js';
import filterRole from '@/mixins/filterRole.js';

export default {
    name: 'group-list',
    components: {
        ElTabs: Tabs,
        ElRadio: Radio,
        ElTabPane: TabPane,
        ElDatePicker: DatePicker,
        AddAppoint,
        AddCourse,
        EditLessons,
    },
    mixins: [timeMixin, filterRole],
    props: ['activeName', 'storeId', 'scheduleId'],
    data() {
        return {
            form: {
                coachId: null,
                date: new Date(),
                placeId: null,
                storeId: null,
            },
            stores: [],
            places: [],
            coachs: [],
            searchText: '',
            groupData: [],
            copy: {
                storeId: null,
                placeId: null,
                srcFrom: null,
                srcTo: null,
                destFrom: null,
                toEnd: null,
            },
            // 查看
            clickIndex: null,
            show: false,
            item: {},
            tableData: [],
            weeks: [],
            cols: [],
        };
    },
    watch: {
        'activeName'(val) {
            if (val === 'first') this.fetchStore();
        },
    },
    async created() {
        if (this.scheduleId) {
            this.clickIndex = this.scheduleId;
            this.$emit('update:scheduleId', false);
            this.handleShow();
        }
        await this.fetchStore();
        // 年月日修改
        const date = new Date();
        this.form.date = this.filterTime(date);
        const weeks = this.handleWeekly(date);
        this.weeks = weeks.eachDay.map(el => {
            el.dayStr = `${el.day.replace('-', this.$t('Week.month'))}${this.$t('Week.day')}`;
            return el;
        });
        this.copy.srcFrom = this.weeks[0].date;
        this.copy.srcTo = this.weeks[this.weeks.length - 1].date;
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    methods: {
        // 时间
        filterTime(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            return `${year}-${month}-${day}`;
        },
        // 获取团课
        fetchGroup() {
            API.get('lesson/team/schedule/list', {
                params: this.form,
            }).then(res => {
                this.cols = [];
                this.groupData = res;
                this.clickIndex = null;
                // 列数
                if (this.groupData.length) {
                    this.groupData.filter(el => {
                        if (!this.cols.includes(el.time)) this.cols.push(el.time);
                    });
                    this.cols.sort();
                }
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = this.storeId ? this.storeId : res[0].id;
                this.selectPlace(this.form.storeId);
                this.fetchCoach();
                this.clickIndex = null;
            });
        },
        // 门店选择
        selectPlace(val) {
            this.form.placeId = null;
            this.places = [];
            API.get(`store/${val}/place/list`).then(res => {
                this.places = []; // 初始化
                this.places.push({ id: null, name: this.$t('Common.all_place') });
                res.map(el => this.places.push(el));
                this.fetchGroup();
            });
        },
        async fetchCoach() {
            this.coachs = [];
            const arr = await this.filterRole(10);
            this.coachs.push({
                id: null,
                nickname: this.$t('Common.all_coath'),
            });
            arr.forEach(el => this.coachs.push(el));
            this.fetchGroup();
        },
        selectDay() {
            this.clickIndex = null;
            const date = new Date(this.form.date);
            const weeks = this.handleWeekly(date);
            this.weeks = weeks.eachDay.map(el => {
                el.dayStr = `${el.day.replace('-', this.$t('Week.month'))}${this.$t('Week.day')}`;
                return el;
            });
            this.fetchGroup();
            this.copy.srcFrom = this.weeks[0].date;
            this.copy.srcTo = this.weeks[this.weeks.length - 1].date;
        },
        handleCreate() {
            // this.$router.push({
            //     name: '',
            // });
        },
        // 查看
        handleShow() {
            if (!this.clickIndex) $ele.$message(this.$t('Course.choose_one'));
            else if (!this.$$filterPermission('课程-团课课表-团课预约列表查看')) {
                this.$router.push('/403');
            } else {
                this.show = true;
                this.fetchItem();
            }
        },
        // 返回
        backList() {
            // this.
            this.clickIndex = null;
            this.item = {};
            this.tableData = [];
            this.show = false;
        },
        fetchItem() {
            this.tableData = [];
            API.get(`lesson/team/schedule/${this.clickIndex}`).then(res => {
                this.item = res;
                this.tableData = res.reserves;
            });
        },
        handleEdit() {
            if (!this.clickIndex) $ele.$message(this.$t('Course.choose_one'));
            else if (!this.$$filterPermission('课程-团课课表-团课课表添加、编辑、修改、删除')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
            else if (this.clickIndex && this.$$filterPermission('课程-团课课表-团课课表添加、编辑、修改、删除'))
            this.$refs.edit.open(this.clickIndex);
        },
        handleAdd() {
            if (this.$$filterPermission('课程-团课课表-团课课表添加、编辑、修改、删除'))
            this.$refs.addCourse.open(this.form.storeId, this.form.date);
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        handleDelete() {
            if (!this.clickIndex) $ele.$message(this.$t('Course.choose_one'));
            else if (!this.$$filterPermission('课程-团课课表-团课课表添加、编辑、修改、删除')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            } else {
                $ele.$confirm(this.$t('Course.delete'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    API.delete(`lesson/team/schedule/${this.clickIndex}/delete`).then(() => {
                        $ele.$message.success(this.$t('Course.delete_success'));
                        this.fetchGroup();
                    });
                }).catch(() => {
                    // $ele.$message('取消操作');
                });
            }
        },
        selectTime() {
            let total;
            const start = new Date(this.copy.srcFrom).getTime();
            const end = new Date(this.copy.srcTo).getTime();
            if (start - end > 0) total = this.getTotal(end, start);
            else total = this.getTotal(start, end);
            const day = this.AddWeeks(new Date(this.copy.destFrom), total);
            this.copy.toEnd = this.filterTime(day);
        },
        // 复制课程
        handlecopy() {
            const form = Object.assign({}, this.copy);
            if (!form.destFrom) return $ele.$message(this.$t('Common.choose_date'));
            form.storeId = this.form.storeId;
            delete form.toEnd;

            const place = this.places.find(el => el.id === form.placeId).name;
            const msg =
                `${this.$t('Course.tip1')} ${form.srcFrom} ~ ${form.srcTo} ${place}${this.$t('Course.tip2')} ${form.destFrom} ~ ${this.copy.toEnd}？`;
            $ele.$confirm(msg, this.$t('Course.copy_confirm'), {
                confirmButtonText: this.$t('Course.tip_confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                API.post('lesson/team/schedule/copy', form).then(res => {
                    $ele.$message.success(this.$t('Message.copy_success'));
                    this.clickIndex = null;
                    // 刷新后获取当前时间课程
                    this.form.date = this.filterTime(new Date());
                    this.fetchGroup();
                });
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
        // 查看时添加预约
        addAppointment() {
            if (this.$$filterPermission('课程-团课课表-代预约团课'))
            this.$refs.appoint.open(this.clickIndex);
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        // 签到
        handleSign(row) {
            const reserveId = row.id;
            $ele.$confirm(this.$t('Message.sign_tip'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-团课课表-团课签到及取消')) {
                    API.put(`lesson/team/schedule/reserve/${reserveId}/sign`).then(() => {
                        $ele.$message.success(this.$t('Message.sign_success'));
                        this.fetchItem();
                    });
                } else {
                    $ele.$alert(this.$t('Course.sign_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: () => {},
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });

        },
        handleCancel(row) {
            const reserveId = row.id;
            $ele.$confirm(this.$t('Message.cancel_confirm'), this.$t('Message.tip_title'), {
                confirmButtonText: this.$t('Message.confirm'),
                cancelButtonText: this.$t('Common.cancel'),
                type: 'warning',
            }).then(() => {
                if (this.$$filterPermission('课程-团课课表-团课签到及取消')) {
                    API.delete(`lesson/team/schedule/reserve/${reserveId}/cancel`).then(() => {
                        $ele.$message.success(this.$t('Message.cancel_success'));
                        this.fetchItem();
                    });
                } else {
                    $ele.$alert(this.$t('Course.cancel_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: () => {},
                    });
                }
            }).catch(() => {
                // $ele.$message('取消操作');
            });
        },
    },
};
</script>

<style lang="scss">
.croup-coach {
    width: calc(100% - 40px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    height: 28px;
    outline: none;
}
.group-handle {
    margin-bottom: 10px;
    color: #697a8e;

    div {
        margin: 0 6px;
    }
}
.group-data-condition {
    width: 265px;
    margin-right: 20px;
    border: 1px solid #e6e6e6;
    padding: 20px 10px;
    flex: 0 0 auto;
}
.group-data-copy {
    font-size: 12px;
    width: 100%;
    margin-top: 15px;
    padding: 20px 10px;
    background: #eee;

    p {
        flex: 0 0 auto;
        margin: 0 12px 0 0;
    }
}
.copy-item {
    margin-bottom: 15px;
}
.copy-text {
    margin-bottom: 15px;
    margin-left: 25px;
}
.group-data-content {
    width: calc(100% - 285px);

    table {
        width: 100%;
        color: #4c4c4c;
        border: 1px solid #e6e6e6;
        border-radius: 3px;
        background: #fff;
    }
    tr {
        text-align: center;
    }
    th, td {
        font-size: 13px;
    }
    th {
        font-weight: 400;
        padding: 10px;
        border-left: 1px solid #e6e6e6;
        &:first-child {
            border-left: none;
        }
    }
    td {
        height: 20px;
        padding: 10px;
        border-left: 1px solid #e6e6e6;
        border-top: 1px solid #e6e6e6;
        color: grey;
        &:first-child {
            border-left: none;
        }
    }
    tr {
        border-bottom: 1px solid #e6e6e6;
    }
    thead {
        td {
            border-top: none;
        }
    }
}
.team-show-single {
    border: 1px solid #e6e6e6;
    padding: 20px 10px;
    margin: 15px 0;
}
.show-single-content {
    width: 100%;
    font-size: 12px;
    color: #4c4c4c;
    div {
        width: calc((100% - 30px) / 4);
        margin-right: 10px;
        line-height: 1.5;

        &:last-child {
            margin-right: 0;
        }
    }
    &:first-child {
        margin-bottom: 10px;
    }
}
.show-single-qiandao,
.show-single-cancle {
    cursor: pointer;

    &:hover {
        color: #05abef;
    }
}
// 课程表
.group-list-day {
    margin-top: 10px;
}
.group-list-single {
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 10px;
    cursor: pointer;

    &.clicked {
        background: #e0f2fa;
    }

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }

    div {
        margin-bottom: 6px;
    }

    .green {
        color: #69b521;
        border: 1px solid #69b521;
    }

    .orange {
        color: #f90;
        border: 1px solid #f90;
    }

    .blue {
        color: #05abef;
        border: 1px solid #05abef;
    }
}
.group-list-icon {
    padding: 1px;
    font-size: 10px;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 4px;
    white-space: nowrap;
}
</style>
